export default __webpack_public_path__ + "static/media/blue_menu_mob.a81012c3.svg";